import { FaGithub, FaLinkedin, FaEnvelope, FaFacebook, FaInstagram } from 'react-icons/fa';

export const socials = [
    {
        id: 1,
        name: "Facebook",
        url: "https://www.facebook.com/profile.php?id=100022343641360",
        icon: <FaFacebook />,
    },
    {
        id: 2,
        name: "Github",
        url: "https://github.com/3bdoKH",
        icon: <FaGithub />,
    },
    {
        id: 3,
        name: "Linkedin",
        url: "https://www.linkedin.com/in/abdo-khairy-391801305/",
        icon: <FaLinkedin />,
    },
    {
        id: 4,
        name: "Instagram",
        url: "https://www.instagram.com/_._3bdo_/",
        icon: <FaInstagram />,
    },
    {
        id: 5,
        name: "the.abdo.kh@gmail.com",
        url: "mailto:the.abdo.kh@gmail.com",
        icon: <FaEnvelope />,
    }
];